import { useEffect, useState } from 'react';
export var useIsClient = function useIsClient(name) {
  if (name === void 0) {
    name = '';
  }

  var _useState = useState(false),
      isClient = _useState[0],
      setIsClient = _useState[1];

  var key = "" + (name ? name + "-" : '') + (isClient ? 'client' : 'server');
  useEffect(function () {
    setIsClient(true);
  }, []);
  return {
    isClient: isClient,
    isServer: !isClient,
    key: key
  };
};